var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('send-service',{attrs:{"service":"letter","header":_vm.$t('W2P_CREATE_LETTER'),"subheader":_vm.$t('W2P_CREATE_LETTER_SUBTEXT')}})}
var staticRenderFns = []

export { render, staticRenderFns }